import { Section, Title } from '../../components/Common/PageElement';
import React from "react";
// import "./index.css"
import {useState} from "react";
import {Container} from "react-bootstrap";
import './tutorial.css'

// Import GIFs - ensure the paths match your file structure
import uploadGif from './TutorialGifs/annoview_upload.gif';
import annotationDetailsGif from './TutorialGifs/right_click_details_annoview.gif';
import selectHighlightGif from './TutorialGifs/left_click_annoview.gif';
import centerSortGif from './TutorialGifs/center_sort_annoview.gif';
import moveGenomesGif from './TutorialGifs/delete_annoview.gif';
import zoomInOutGif from './TutorialGifs/annoview_zoom.gif';
import changeTaxonomyGif from './TutorialGifs/annoview_taxonomy.gif';
import changeAnnotationTypeGif from './TutorialGifs/annoview_type.gif';
import searchAnnotationsGif from './TutorialGifs/annoview_search_annotation.gif';

function Tutorial() {
    return (
        <Section id={'tutorial'}>
            <Container>
                <div className="tutorial-container">
                    <h2>Welcome to AnnoView!</h2>
                    <h6>Here are some basic operations you can try.</h6>
                    <h6>If you have any questions, feel free to contact us!</h6>
                    <hr className="solid"/>
                    <h3>Main Features:</h3>
                    <div className="feature-section">
                        <h4 className="feature-title">Upload Files:</h4>
                        <img src={uploadGif} alt="Uploading Files" />
                    </div>
                    <hr className="solid"/>

                    <h3 className="feature-explanation">Example: Search for gene neighborhoods of McrA (Methyl-coenzyme M reductase subunit alpha) homologs in the <span style={{'fontStyle':'italic'}}>Methanosarcina</span> genus.</h3>
                    <hr className="dotted"/>
                    <div className="feature-section">
                        <h4 className="feature-title">Interactive Genomes:</h4>
                        <h6>Check annotation details and protein sequences (Right-click):</h6>
                        <img src={annotationDetailsGif} alt="Annotation Details" />

                        <h6>Select and highlight genes with the same annotation (Left-click):</h6>
                        <img src={selectHighlightGif} alt="Select and Highlight Genes" />

                        <h6>Center sort genomes, this will reorder the genomes (Right-click):</h6>
                        <img src={centerSortGif} alt="Center Sort Genomes" />

                        <h6>Move genomes (Drag):</h6>
                        <img src={moveGenomesGif} alt="Move Genomes" />
                    </div>


                    <hr className="solid"/>
                    <div className="feature-section">
                        <h4 className="feature-title">Search Bar Usage:</h4>
                        <h6>Zoom in/out:</h6>
                        <img src={zoomInOutGif} alt="Zoom In/Out" />

                        <h6>Change taxonomy:</h6>
                        <img src={changeTaxonomyGif} alt="Change Taxonomy" />

                        <h6>Change annotation type:</h6>
                        <img src={changeAnnotationTypeGif} alt="Change Annotation Type" />
                    </div>
                    <hr className="solid"/>
                    <div className="feature-section">
                        <h4 className="feature-title">Search Annotations:</h4>
                        <img src={searchAnnotationsGif} alt="Search Annotations" />
                    </div>
                </div>
            </Container>
        </Section>
    );
}

export default Tutorial;
